import {
  getPage,
  getUserGroupPage
} from '@/api/maintaindevicerecordserv'

export default {
  state: {
    state_MaintainDeviceRecord_GetPageResult: null,
    state_MaintainDeviceRecord_GetUserGroupPageResult: null
  },
  mutations: {
    SET_MAINTAINDEVICERECORD_GETPAGE_RESULT: (state, rst) => {
      state.state_MaintainDeviceRecord_GetPageResult = rst
    },
    SET_MAINTAINDEVICERECORD_GETUSERGROUPPAGE_RESULT: (state, rst) => {
      state.state_MaintainDeviceRecord_GetUserGroupPageResult = rst
    }
  },
  actions: {
    MaintainDeviceRecordServ_GetPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MAINTAINDEVICERECORD_GETPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MAINTAINDEVICERECORD_GETPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MaintainDeviceRecordServ_GetUserGroupPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getUserGroupPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MAINTAINDEVICERECORD_GETUSERGROUPPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MAINTAINDEVICERECORD_GETUSERGROUPPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  getters: {
    get_MaintainDeviceRecord_GetPageResult: state => {
      return state.state_MaintainDeviceRecord_GetPageResult
    },
    get_MaintainDeviceRecord_GetUserGroupPageResult: state => {
      return state.state_MaintainDeviceRecord_GetUserGroupPageResult
    }
  }
}
